"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.list.searchPlaceholder': 'Buscar políticas de acceso...',
};
